/* eslint-disable react/no-unknown-property */
/* eslint-disable new-cap */
/* eslint-disable react/prop-types */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/**
 * Copyright © Scandiweb, Inc. All rights reserved.
 *
 * @category    Puma
 * @package     Puma_Tabby
 * @author      Beshoy Samuel <info@scandiweb.com>
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import INTERVAL_RATE from './TabbyPdp.config';

/** @namespace Scandipwa/Component/TabbyPdp/Component */
export class TabbyPdpComponent extends PureComponent {
    static propTypes = {
        formatedPrice: PropTypes.number,
        order: PropTypes.number,
        selector: PropTypes.string,
        merchantCode: PropTypes.string,
        publicKey: PropTypes.string,
        source: PropTypes.string,
        currency: PropTypes.string,
        currencyRate: PropTypes.string,
        theme: PropTypes.string,
        productType: PropTypes.string,
        error: PropTypes.string,
        isLoading: PropTypes.bool
    };

    static defaultProps = {
        formatedPrice: null,
        order: 0,
        selector: null,
        merchantCode: null,
        publicKey: null,
        source: null,
        currency: null,
        currencyRate: null,
        theme: null,
        productType: null,
        error: null,
        isLoading: null
    };

    existTabbyProductWidget = setInterval(() => {
        if (window.TabbyPromo) {
            this.renderWidget();
            clearInterval(this.existTabbyProductWidget);
        }
    }, INTERVAL_RATE);

    componentDidUpdate(prevProps) {
        const { prevFormatedPrice } = prevProps;
        const { formatedPrice } = this.props;

        if (prevFormatedPrice !== formatedPrice) {
            this.renderWidget();
        }
    }

    componentWillUnmount() {
        clearInterval(this.existTabbyProductWidget);
    }

    isArabicCacheWorkaround() {
        const doc = document.documentElement;

        if (doc) {
            return doc.getAttribute('dir') === 'rtl';
        }

        return false;
    }

    renderWidget = () => {
        const {
            formatedPrice,
            selector,
            merchantCode,
            publicKey,
            source,
            currency,
            currencyRate,
            theme,
            productType,
            error,
            isLoading
        } = this.props;

        if (!error
            && !isLoading
            && publicKey
            && window.TabbyPromo !== undefined
        ) {
            window.TabbyPromo({
                selector,
                merchantCode,
                publicKey,
                lang: this.isArabicCacheWorkaround() ? 'ar_SA' : 'en_US',
                source,
                currency,
                currencyRate,
                theme,
                productType,
                price: formatedPrice
            });
        }
    };

    render() {
        const {
            publicKey, error, isLoading, order
        } = this.props;

        if (isLoading || !publicKey || error) {
            return null;
        }

        return (
            <div
              id="tabbyPromo"
              block="tabby"
              elem="product-widget"
              style={ { order } }
            />
        );
    }
}

export default TabbyPdpComponent;
